export default __webpack_public_path__ + "static/media/github-workflow-inputs.ceac0b69.png";